import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { Grid } from '@mui/material';
import HistoryIcon from '@mui/icons-material/History';
import HowToRegIcon from '@mui/icons-material/HowToReg';
import AssignmentTurnedIn from '@mui/icons-material/AssignmentTurnedIn';
import DocumentScoringResultSummaryBeta from './DocumentScoringResultSummaryBeta';
import { CollapseCard, TextField, Button } from '@totalsoft/rocket-ui';
import { withRights } from '../../../../../providers/RightsConsumer';
import { RightsContext } from 'providers/RightsContext';

export const DocumentScoringResultComponentBeta = ({
  scoringResult,
  t,
  scoringInProgress,
  rights,
  generateScoring,
  viewScoringHistory
}) => {
  const { isImage, folderScoringHistoryRead } = useContext(RightsContext);

  return (
    <React.Fragment>
      <CollapseCard
        icon={AssignmentTurnedIn}
        title={t('DocumentEdit.Scoring.ScoringResult.Title')}
        subheader={<DocumentScoringResultSummaryBeta scoringResult={scoringResult} />}
        hideSubheaderOnExpand
        toggleOnHeaderClick
      >
        <Grid container spacing={2}>
          <Grid item xs={12} sm={4}>
            <TextField
              disabled
              fullWidth
              value={scoringResult.eligibilityCriteria || ''}
              label={t('DocumentEdit.Scoring.ScoringResult.EligibilityCriteria')}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <TextField
              disabled
              fullWidth
              value={scoringResult.assetRating || ''}
              label={t('DocumentEdit.Scoring.ScoringResult.AssetScoreClass')}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <TextField
              disabled
              fullWidth
              value={scoringResult.msRatingClient || ''}
              label={t('DocumentEdit.Scoring.ScoringResult.ClientScoreClassBeta')}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <TextField
              disabled
              fullWidth
              value={scoringResult.minimumDownPaymentCriteria || ''}
              label={t('DocumentEdit.Scoring.ScoringResult.MinimumDownPaymentCriteria')}
            />
          </Grid>
          <Grid item xs={12}>
            {!isImage && (
              <Grid container spacing={1}>
                <Grid item>
                  <Button right onClick={viewScoringHistory} disabled={scoringInProgress || !folderScoringHistoryRead}>
                    <HistoryIcon style={{ marginRight: 5 }} />
                    {t('OfferEdit.ScoringHistory.Title')}
                  </Button>
                </Grid>
                <Grid item>
                  <Button
                    right
                    onClick={generateScoring}
                    disabled={rights.readOnlyFull || scoringInProgress || !rights.folderComputeScoring}
                  >
                    <HowToRegIcon style={{ marginRight: 5 }} />
                    {scoringInProgress ? t('DocumentEdit.Scoring.ScoringInProgress') : t('DocumentEdit.Scoring.ProcessScoring')}
                  </Button>
                </Grid>
              </Grid>
            )}
          </Grid>
        </Grid>
      </CollapseCard>
    </React.Fragment>
  );
};

DocumentScoringResultComponentBeta.propTypes = {
  scoringResult: PropTypes.object,
  t: PropTypes.func.isRequired,
  scoringInProgress: PropTypes.bool.isRequired,
  generateScoring: PropTypes.func.isRequired,
  viewScoringHistory: PropTypes.func.isRequired,
  rights: PropTypes.object.isRequired
};
export default withTranslation()(withRights(DocumentScoringResultComponentBeta));
